module.exports = __webpack_public_path__ + "img/plus.65e5803c.svg";